import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, getStoredMirror } from '../../hooks/useAuth';
import { getLoginTheme, rememberTheme } from '../../config/themes';
import PortalTopBar from '../../features/portal-frame/PortalTopBar';
import PortalFooter from '../../features/portal-frame/PortalFooter';
import PortalGlows from '../../features/portal-frame/PortalGlows';
import LoginForm from './components/LoginForm';

const NO_ACCOUNT = 'Нет аккаунта? Обратитесь к менеджеру';

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  // Тема последнего входа на устройстве; новый посетитель — монохром.
  const theme = getLoginTheme();
  const industrial = theme === 'industrial';

  useEffect(() => {
    if (user) navigate('/vacancy', { replace: true });
  }, [user, navigate]);

  const handleLogin = async (loginVal: string, password: string) => {
    const ok = await login(loginVal, password);
    if (ok) {
      rememberTheme(getStoredMirror().id);
      navigate('/vacancy', { replace: true });
    }
    return ok;
  };

  return (
    <div
      data-theme={theme}
      className="min-h-screen bg-background-50 flex flex-col relative overflow-hidden theme-grid"
    >
      {theme === 'default' && <PortalGlows />}

      <PortalTopBar industrial={industrial}>
        <p className="hidden sm:flex items-center gap-2 text-sm text-foreground-500">
          <i className="ri-question-line" />
          {NO_ACCOUNT}
        </p>
      </PortalTopBar>

      <main className="flex-1 flex flex-col items-center justify-center px-4 sm:px-6 py-12 sm:py-16 relative z-10">
        <div className="text-center mb-10 sm:mb-12">
          {theme === 'default' ? (
            <span className="inline-block text-xs font-semibold text-primary-500 bg-primary-500/10 border border-primary-500/20 rounded-full px-4 py-1.5 mb-4">
              Вход в личный кабинет
            </span>
          ) : (
            <p className="eyebrow mb-5">Вход в личный кабинет</p>
          )}
          <h1 className={`${industrial ? 'text-4xl md:text-5xl mb-4' : 'text-3xl sm:text-4xl mb-3'} font-bold text-ink`}>
            Добро <mark>пожаловать</mark>
          </h1>
          <p className="text-foreground-500 text-base">Логин и пароль выдаёт ваш менеджер</p>
        </div>

        <div className="w-full max-w-md bg-surface-1 border border-surface-3 rounded-2xl p-6 sm:p-10">
          <LoginForm onLogin={handleLogin} />
        </div>

        <p className="sm:hidden mt-6 text-xs text-foreground-400 text-center">{NO_ACCOUNT}</p>
      </main>

      <PortalFooter stripes={theme !== 'default'} />
    </div>
  );
}
